import { render, staticRenderFns } from "./FloralVarietyNicknamesTable.vue?vue&type=template&id=0bd0e626"
import script from "./FloralVarietyNicknamesTable.vue?vue&type=script&lang=js"
export * from "./FloralVarietyNicknamesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports